import { ListItem, ListItemButton } from "@mui/material";
import PropTypes from "prop-types";

export default function SettingsOption({ children, ...props }) {
  return (
    <ListItem
      disablePadding
      sx={{
        minHeight: 48,
        width: 1,
        border: "1px solid",
        borderColor: "divider",
        boxSizing: "content-box",
        borderRadius: 1,
        height: "auto",
        "&:hover": {
          background: "inherit",
          borderColor: "dividerHover",
        },
      }}
    >
      <ListItemButton {...props} sx={{ minHeight: 48, py: 0.5 }}>
        {children}
      </ListItemButton>
    </ListItem>
  );
}

SettingsOption.propTypes = {
  children: PropTypes.node,
};
